import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }  from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'wor-loan-car-return',
  template: `
    <div class="modal-header clearfix bg-info title">
      <div class="pull-left">
        <h1 *ngIf="loanCar?.loan_status === 'A'">
          <i class="fa fa-tag"></i>
          {{ 'LOAN_CAR_SPACE.RETURN_LOAN_CAR' | translate }}
          <span *ngIf="loanCar?.invoice_id && !loanCar?.event_id">
            {{ 'LOAN_CAR_SPACE.FOR_JOB' | translate:{ job: invoice?.job_card_number } }}
          </span>
          <span *ngIf="!loanCar?.invoice_id && loanCar?.event_id">
            {{ 'LOAN_CAR_SPACE.FOR_BOOKING' | translate:{ num: event?.event_number } }}
          </span>
          <span *ngIf="loanCar?.invoice_id && loanCar?.event_id">
            {{ 'LOAN_CAR_SPACE.FOR_BOOKING_JOB' | translate:{ num: event?.event_number, job: invoice?.job_card_number } }}
          </span>
        </h1>
      </div>
    </div>
    <form class="form-horizontal" #returnForm="ngForm" novalidate
      (ngSubmit)="returnForm.valid && returnLoan()">
      <div class="modal-body clearfix">
        <div class="top-buffer info" *ngIf="loanCar?.id">
          <fieldset class="top-buffer">
            <div class="col-md-6">
              <label translate="CUSTOMER_SPACE.CUSTOMER_DETAILS"></label>
              <p>
                <span>{{ loanCar.contact_first_name }}</span>
                <span>{{ loanCar.contact_last_name }}</span>
              </p>
              <p>
                <span>{{ loanCar.contact_address1 }}</span><span>, {{ loanCar.contact_address2 }}</span><span>, {{ loanCar.contact_suburb }}</span><span>, {{ loanCar.contact_state }}</span><span>, {{ loanCar.contact_postcode }}</span>
              </p>
              <p>
                <span>{{ 'LOAN_CAR_SPACE.PHONE_SHORT' | translate }}: {{ loanCar.contact_phone }}</span>
                <span> {{ 'LOAN_CAR_SPACE.MOBILE_SHORT' | translate }}: {{ loanCar.contact_mobile }}</span>
                <span> {{ 'GENERAL_SPACE.FIELD.EMAIL' | translate }}: {{ loanCar.contact_email }}</span>
              </p>
            </div>
            <div class="col-md-6">
              <label translate="LOAN_CAR_SPACE.LOAN_VEHICLE_DETAILS"></label>
              <p><span>{{ loanVehicle?.plate_number }}</span></p>
              <p>
                <span>{{ loanVehicle?.make }}</span>
                <span> {{ loanVehicle?.model }}</span>
                <span> {{ loanVehicle?.model_code }}</span>
                <span> {{ loanVehicle?.model_series }}</span>
              </p>
              <p>
                <span>{{ loanVehicle?.build_date }}</span>
                <span> {{ loanVehicle?.colour }}</span>
              </p>
            </div>
          </fieldset>
          <fieldset class="top-buffer">
            <div class="col-md-6">
              <label translate="LOAN_CAR_SPACE.LICENSE_DETAILS"></label>
              <p><span>{{ 'LOAN_CAR_SPACE.LICENSE_NUMBER' | translate }}: {{ loanCar.license_number }}</span></p>
              <p><span>{{ 'LOAN_CAR_SPACE.LICENSE_EXPIRY' | translate }}: {{ loanCar.license_expiry | globalDate }}</span></p>
            </div>
            <div class="col-md-6">
              <label translate="LOAN_CAR_SPACE.LOAN_BOOKING_DETAILS"></label>
              <p><span>{{ 'LOAN_CAR_SPACE.BOOKING_START' | translate }}: {{ loanCar.local_booking_start_time | dateTime }}</span></p>
              <p><span>{{ 'LOAN_CAR_SPACE.BOOKING_END' | translate }}: {{ loanCar.local_booking_end_time | dateTime }}</span></p>
              <p><span>{{ 'LOAN_CAR_SPACE.LOAN_START' | translate }}: {{ loanCar.local_start_time | dateTime }}</span></p>
              <p *ngIf="loanCar.local_return_time">
                <span>{{ 'LOAN_CAR_SPACE.LOAN_RETURN' | translate }}: {{ loanCar.local_return_time | dateTime }}</span>
              </p>
            </div>
          </fieldset>
          <fieldset class="top-buffer">
            <div class="col-md-6">
              <label translate="LOAN_CAR_SPACE.PRE_LOAN_CHECK_DETAILS"></label>
              <p><span>{{ 'VEHICLE_SPACE.ODOMETER' | translate }}: {{ loanCar.odometer_before }}</span></p>
              <p><span>{{ 'LOAN_CAR_SPACE.FUEL_LEVEL' | translate }}: {{ loanCar.fuel_level_before }}%</span></p>
              <p><span>{{ 'LOAN_CAR_SPACE.CLEAN' | translate }}: {{ loanCar.loan_vehicle_clean_before }}</span></p>
            </div>
            <div class="col-md-6">
              <p><span>{{ 'GENERAL_SPACE.FIELD.NOTES' | translate }}: {{ loanCar.note_before }}</span></p>
              <p><span>{{ 'INSPECTIONS_SPACE.SERVICE_ADVISERS.SERVICE_ADVISER' | translate }}: {{ serviceAdviserBefore?.display_name }}</span></p>
              <p><span>{{ 'LOAN_CAR_SPACE.TERMS_AGREED_TO_BY_CUSTOMER' | translate }}: {{ loanCar.terms_agreed_to_by_customer }}</span></p>
            </div>
          </fieldset>
        </div>
        <div class="row" *ngIf="loanCar?.loan_vehicle_id">
          <fieldset class="top-buffer">
            <label translate="LOAN_CAR_SPACE.VEHICLE_CHECK_RETURN"></label>
          </fieldset>
          <fieldset class="col-md-3">
            <label class="control-label" for="odometer_return"
              translate="VEHICLE_SPACE.ODOMETER"></label>
            <div class="controls">
              <input id="odometer_return" name="odometer_return"
                class="form-control" type="text"
                numberInput [min]="0" [max]="10000000"
                [(ngModel)]="loanCar.odometer_return"
                [readonly]="!editable">
            </div>
          </fieldset>
          <fieldset class="col-md-3">
            <label class="control-label" for="fuel_level_return"
              translate="LOAN_CAR_SPACE.FUEL_LEVEL"></label>
            <div class="controls input-group">
              <input type="text" id="fuel_level_return" name="fuel_level_return"
                class="form-control"
                numberInput [min]="0" [max]="100"
                [(ngModel)]="loanCar.fuel_level_return"
                [readonly]="!editable">
              <span class="input-group-addon">
                <span class="symbol">%</span>
              </span>
            </div>
          </fieldset>
          <fieldset class="col-md-2">
            <label class="control-label" for="clean_return"
              translate="LOAN_CAR_SPACE.LOAN_VEHICLE_CLEAN"></label>
            <label class="switch switch-success companytax">
              <input id="clean_return" name="clean_return"
                class="switch-input" type="checkbox"
                [(ngModel)]="loanCar.loan_vehicle_clean_return"
                [disabled]="!editable">
              <span class="switch-label"
                [attr.data-off]="'GENERAL_SPACE.SWITCH.NO' | translate"
                [attr.data-on]="'GENERAL_SPACE.SWITCH.YES' | translate"></span>
              <span class="switch-handle"></span>
            </label>
          </fieldset>
          <fieldset class="col-sm-4">
            <label for="service_adviser" class="control-label"
              translate="LOAN_CAR_SPACE.CHECKED_BY"></label>
            <div class="autocomplete autocomplete--contain">
              <input type="text" class="form-control"
                name="service_adviser" id="service_adviser"
                [worTypeahead]="serviceAdviserSearch"
                [(ngModel)]="serviceAdviserSearch.value"
                [readonly]="!editable">
            </div>
          </fieldset>
        </div>
        <div class="row">
          <fieldset class="col-md-12">
            <label class="control-label" for="note"
              translate="LOAN_CAR_SPACE.LOAN_CAR_NOTE"></label>
            <textarea id="note" name="note" type="text"
              [(ngModel)]="loanCar.note_return" rows="6"
              [readonly]="!editable"></textarea>
          </fieldset>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-success"
          *ngIf="editable"
          translate="LOAN_CAR_SPACE.RETURN"></button>
        <button type="button" class="btn btn-default pull-left"
          (click)="modal.dismiss()"
          translate="GENERAL_SPACE.BUTTON.CANCEL"></button>
      </div>
    </form>
  `
})
export class LoanCarReturnComponent implements OnInit {
  @Input() loanCar             : any;
  @Input() loanVehicle         : any;
  @Input() invoice             : any;
  @Input() event               : any;
  @Input() customer            : any;
  @Input() serviceAdviserBefore: any;
  @Input() serviceAdviserReturn: any;

  editable = false;
  serviceAdviserSearch: any;

  constructor (
    public  modal           : NgbActiveModal,
    private apiService      : ApiService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {
    this.editable = this.loanCar?.loan_status === 'A';
    this.serviceAdviserReturn = this.serviceAdviserReturn || {};

    this.serviceAdviserSearch = {
      value: this.serviceAdviserReturn?.display_name || '',
      query: (typed: string) => this.apiService.get('/service_advisers/list', [typed, 0, '*']),
      format: (adviser: any) => adviser ? adviser.display_name : '',
      choose: (adviser: any) => {
        this.serviceAdviserReturn.id = adviser.id;
        this.serviceAdviserReturn.display_name = adviser.display_name;
        this.loanCar.confirmed_by_return = adviser.id;
      }
    };
  }

  returnLoan (): void {
    this.apiService.patch('/loan_car', this.loanCar, 'loan_car')
      .then(() => this.apiService.get('/loan_car/return_loan_car', this.loanCar.id))
      .then(() => {
        this.messagesService.show(
          this.translateService.instant('LOAN_CAR_SPACE.LOAN_CAR_RETURNED'),
          'success'
        );
        this.modal.close();
      })
      .catch(err => this.messagesService.error(err));
  }
}
